import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20beautiful%20dreamy%20anime%20illustration%20of%20a%20magical%20library%20floating%20in%20the%20sky%20with%20books%20and%20scrolls%20scattered%20around%2C%20warm%20golden%20sunset%20light%2C%20artistic%20and%20ethereal%20atmosphere%2C%20soft%20color%20palette%20with%20coral%20and%20amber%20tones%2C%20fantasy%20aesthetic%2C%20high%20quality%20illustration%2C%20inspiring%20and%20creative%20composition&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="今日同人库 - 每日精选同人内容聚合平台"
        title="今日同人库"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 md:mb-6 leading-tight">
          今日同人库
        </h1>
        <p className="text-base md:text-xl text-background-50/85 max-w-2xl mb-4 leading-relaxed">
          每日精选同人内容聚合平台 —— 汇聚最新同人小说、画作、音乐与周边资讯
        </p>
        <p className="text-sm md:text-base text-background-50/65 max-w-xl mb-8 leading-relaxed">
          发现你最爱的CP与原创同人作品，每天更新，让同人热情燃烧不息
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/doujin-novel"
            className="px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            探索同人作品
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 font-medium rounded-lg hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer text-sm border border-background-50/30"
          >
            了解我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-6 mt-10">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-2 text-background-50/80 hover:text-background-50 transition-colors cursor-pointer text-sm"
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-full bg-background-50/15">
                <i className={`${cat.icon} text-xs`}></i>
              </div>
              <span className="whitespace-nowrap">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}